import { Box, Flex, Space, Button, Divider, Text } from '@mantine/core';
import { InfoItem } from '../../../../component';
import classes from './BookInPerson.module.css';
import { useUserMeStore } from '../../../../store';
import { EventSchemaDto, EventsSchemaDto } from '@web/common';
import { splitLocationString } from '../../../../util/appointment/splitLocationString';
import { WorkingHours } from './WorkingHours';
import { useTranslation } from 'react-i18next';
import { makeAppointment } from './makeAppointment';
import { MyIcon } from '@web/common-ui';

export const BookingItemList = ({
  data,
  selectedTeamSlug,
  setSelectedTeamSlug,
  selectedEventSlug,
  setSelectedEventSlug,
  setSelectedLocation,
}: {
  data: EventsSchemaDto;
  selectedTeamSlug: string | null;
  setSelectedTeamSlug: (slug: string) => void;
  selectedEventSlug: number | null;
  setSelectedEventSlug: (slug: number) => void;
  selectedLocation: string | null;
  setSelectedLocation: (location: string) => void;
}) => {
  const userMeStore = useUserMeStore();
  const { t } = useTranslation('appointment-booking');

  if (data.length === 0) {
    return (
      <Box>
        <Text>{t('NoEventsFound')}</Text>
      </Box>
    );
  }

  return data.map((event: EventSchemaDto, index: number) => (
    <Box key={index} style={{ cursor: 'pointer' }}>
      <Flex
        className={classes.itemContainer}
        bg={
          selectedTeamSlug === event.team.slug && selectedEventSlug === event.id
            ? '#F7F7F7'
            : '#fff'
        }
        onClick={() => {
          setSelectedTeamSlug(event.team.slug);
          setSelectedEventSlug(event.id);
          setSelectedLocation(splitLocationString(event.locations).link);
        }}
        style={{
          borderColor:
            selectedTeamSlug === event.team.slug &&
            selectedEventSlug === event.id
              ? '#3D7F53'
              : '#fff',
        }}
      >
        <Flex direction="column" gap="5px">
          <Text fw="600">{event.title}</Text>
          <Space />
          <InfoItem
            icon={<MyIcon name="location" className={classes.icon} />}
            text={splitLocationString(event.locations).address}
            textColor="#7F898F"
          />
          <InfoItem
            icon={<MyIcon name="clock" className={classes.icon} />}
            text={<WorkingHours workingHours={event.workingHours} />}
            textColor="#7F898F"
          />
        </Flex>

        <Button
          fw="500"
          onClick={() =>
            makeAppointment(
              event.team.slug,
              event.slug,
              event.id,
              userMeStore.myInfo!.id,
              userMeStore.myInfo!.userSearchID,
              userMeStore.myInfo!.email,
            )
          }
        >
          {t('SelectAppointment')}
        </Button>
      </Flex>
      <Divider color="#B1B1B1" />
    </Box>
  ));
};
